/*
 * YMM routing: after a vehicle is picked in the EasySearch widget, send the shopper to that
 * vehicle's category landing page (/pages/<slug>) instead of the raw tag listing.
 * Registered on window 'load' so it runs after the older handler in global.js and overrides it.
 */
window.addEventListener('load', function () {
  var ROUTES = {
    'wrangler': 'wrangler',
    'gladiator': 'gladiator-jt',
    'bronco': 'bronco',
    'f-150': 'f-150',
    'sierra 1500': 'sierra-1500',
    'silverado 1500': 'silverado-1500',
    '1500': 'ram-1500',
    'tacoma': 'tacoma',
    '4runner': '4runner',
    'land cruiser': 'land-cruiser',
    'colorado': 'colorado',
    'canyon': 'canyon',
    'grand cherokee': 'grand-cherokee-wk2'
  };

  document.addEventListener('easysearch_params_saved', function (event) {
    var holder = event.detail && event.detail.holder;
    var url = event.detail && event.detail.url;
    if (typeof easysearch === 'undefined' || !easysearch.curIndex || !holder || !url) return;

    var btn = holder.querySelector('.easysearch-btn-search');
    var parts = easysearch.curIndex.split(',');
    var year = parts[0] ? parseInt(parts[0].trim(), 10) : null;
    var model = parts[2] ? parts[2].trim().toLowerCase() : null;
    if (!btn || !model || !ROUTES[model]) return;

    var slug = ROUTES[model];
    if (model === 'wrangler' && year) {
      if (year <= 2006) slug = 'wrangler-tj';
      else if (year <= 2017) slug = 'wrangler-jk';
      else slug = 'wrangler-jl';
    }

    var newUrl = url.replace(/\/collections\/all\/.*$/, '/pages/' + slug);
    btn.setAttribute('href', newUrl);
    if (holder.esparams) holder.esparams.url = newUrl;
  });
});
